import { render, staticRenderFns } from "./SignNSubmitFrame.vue?vue&type=template&id=7044cffa"
import script from "./SignNSubmitFrame.vue?vue&type=script&lang=js"
export * from "./SignNSubmitFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports